import classNames from "classnames";
import React from "react";

export function StickyBottomBar({ children, className }: React.PropsWithChildren<{ className?: string }>) {
    return <div className={classNames('flex flex-row gap-3 mt-8 bg-white p-4 lg:px-0 border-t lg:border-none sticky bottom-0 lg:static', className)}>
        {children}
    </div>
}